module.exports = __webpack_public_path__ + "01_long_black.f8cdd6e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_long_black.png
// module id = ac2V
// module chunks = 0